export const chart_bullet_qualitative_range_ColorScale_500 = {
  "name": "--pf-v5-chart-bullet--qualitative-range--ColorScale--500",
  "value": "#6a6e73",
  "var": "var(--pf-v5-chart-bullet--qualitative-range--ColorScale--500, #6a6e73)"
};
export default chart_bullet_qualitative_range_ColorScale_500;